module.exports = "/static/assets/25497089eb1925a13ab0ce12d6df6a72.gif";